import React from 'react';
import Reel from './Reel';
import { Link } from 'react-router-dom';
export default function Hero() {
  return (
    <>
    <section className='pt-20 md:pt-[0px]'>
<div className="text-center flex flex-col py-2">
        <h1 className='text-3xl md:text-6xl font-semibold 
        md:font-bold inline-block bg-gradient-to-r from-black to-yellow-400
         via-red-500 bg-clip-text text-transparent'>D.B</h1>
      <h2 className='text-2xl md:text-4xl font-semibold md:font-bold 
      inline-block bg-gradient-to-r from-red-700 to-yellow-400 via-red-500 bg-clip-text text-transparent'>Digital Marketing With Bikash</h2>

</div>
    <div className="hero-1 text-center text-white py-4 px-4">

      <h1 className='text-3xl font-semibold text-center'>
        The Best Platform To Grow Your Business In Nepal
      </h1>
      <div className="btns flex justify-center m-2">
        <Link to='/contact'>
             <button type="button" className='p-1 bg-red-700 m-2 border-2 border-white rounded-lg active:bg-transparent hover:border-none'>Contact Us &#8594;</button>

        </Link>
        <Link  to='/service'>

        <button type="button" className="p-1 bg-trasparent m-2 rounded-lg border-2 border-red-700 active:bg-red-500 hover:border-none" > Our Services &#8594;</button>

        </Link>
      </div>
         </div>


        <div className='hero-2 overflow-hidden  text-black flex rounded-2xl border-2 flex justify-evenly  flex-col-reverse md:flex-row'>
                <div className='left  text-center bg-white sm:w-[50%]  flex justify-center flex-col'>  
             <h1 className="text-2xl text-red-700 font-bold sm:text-4xl ">D.B</h1>
  <h2 className="text-xl font-semibold sm:text-3xl">Digital Marketing With Bikash</h2>

  <p> Digital marketing helps businesses grow online by reaching the right audience through powerful internet strategies. Our digital marketing services include social media marketing, search engine optimization (SEO), content creation, Google and Facebook advertising, website promotion, brand awareness campaigns, and customer engagement solutions. We focus on increasing your online visibility, attracting potential customers, and helping your business achieve long-term success in the digital world with creative and result-driven marketing strategies.</p>

                        </div>

        <div className='right flex justify-center'>  
          <img src ="./images/Bk-hero2.png"  alt="digital Marketing" className='' loading="lazy"  />
            </div>


         </div>
        <div  className=" hero3 pt-2">
          <div className=''>
            <h1 className=' text-center text-white text-2xl md:text-3xl font-semibold md: font-bold'> Why Digital Marketing?</h1></div>
          <h2 className='text-center text-white text-xl md:texr-2xl md:font-semibold '>view videoes to know why you should choose to digitalise your business  </h2>
          <div className=' m-4'>
<Reel/>
          </div>

      </div>
      <div className="hero4">
        <div className=" bg-white text-center py-4">
          <h1 className='text-red-700 text-2xl md:text-3xl font-bold'>What We offers ?</h1>
          <p>Our digital marketing team offers you the powerful strategies to help your businesses grow online, reach targeted audiences, and increase brand awareness. Through services like social media marketing, search engine optimization (SEO), content creation, email marketing, and online advertising, businesses can connect with customers more effectively and boost sales in the digital world. Our digital marketing solutions are designed to build strong online presence, improve engagement, and deliver measurable results for long-term success. </p>
          <h3 className='text-red-500 text-2xl'>In Addition</h3>
          <p>We also provide the facility of website development  and responsivness analysis - controlled by <a href="https://www.facebook.com/prem.shah.272930" className='text-blue-900 text-xl font-bold'target='_blank'>Prem kumar Sah</a></p>

        
        </div>
      </div>
      <div className="m-2 grid  grid-cols-1 md:grid-cols-2 py-2">
     <div className='w-full'>

<img src="./images/echo.png" alt="echo" className='' />
        </div>


             <div className='bg-transparent  flex items-center  justify-center md:mr-4 '>
              <div className='bg-white flex flex-col items-center rounded-2xl'>
<h1 className='text-red-700 font-semibold md:font-bold text-xl md:text-3xl '> You Know!!</h1>
<p className='m-2  leading-normal '>
  Listing your business on Google Business Profile helps customers easily find your company online through Google Search and Google Maps. A well-optimized business profile increases visibility, builds trust, and allows customers to view important details such as location, contact number, opening hours, photos, reviews, and services. It also improves local SEO, helping your business appear in nearby searches and attract more potential customers. With features like customer reviews, direct messaging, and regular updates, a Google Business Profile is a powerful and cost-effective way to grow your brand and connect with local customers.
</p>
                    </div>

            </div>
  </div>
    </section>
      
    </>
  )
}
